import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import useJobs from '@/hooks/useJobs/useJobs'

import { JobsListColumns } from './Jobs.data'
import MobileJobCard from './MobileJobCard'

export const Jobs = () => {
  const { isMobile } = useMobile()
  const jobsQuery = useJobs()
  const jobs = jobsQuery?.data?.jobs || []
  const columns = useMemo(() => {
    return JobsListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideLengthOfStayFilter={true}
        hideReservationMoveInFilter={true}
        hideReservationMoveOutFilter={true}
        hideSearch={false}
        listType={FilterTypes.JOBS}
        title="Jobs"
      />

      {jobsQuery?.isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            jobs?.length > 0 ? (
              jobs?.map((job) => <MobileJobCard job={job} key={job.id} />)
            ) : (
              <NoResults />
            )
          ) : (
            <Table columns={columns as any} data={jobs} />
          )}
        </>
      )}
    </div>
  )
}
